import {useEffect} from 'react';
import {useNavigate} from 'react-router-dom';
import {OAuth2Params} from '../types';
import {OAuth2Service} from '../services/OAuth2Service';
import {Account} from '../../accounts/types';
import {ActivityEventsService} from '../../debug-mode/activity-events/services/ActivityEventsService';

export const useOAuth2Authorization = (accounts: Account[], params: OAuth2Params) => {
    const navigate = useNavigate();
    const oauth2Service = new OAuth2Service();

    useEffect(() => {
        const authorizeWithSession = async () => {
            if (accounts.length === 0) {
                return;
            }

            const result = await oauth2Service.authorize(accounts, params);

            if (result.success && result.redirectUrl) {
                ActivityEventsService.add(
                    'OAuth2 Authorization Successful',
                    `OAuth2 flow completed, redirecting to: ${result.redirectUrl}`,
                    undefined
                );
                oauth2Service.redirectToApp(result.redirectUrl);
            } else {
                ActivityEventsService.add(
                    'OAuth2 Authorization Failed',
                    `OAuth2 error: ${result.error?.error} - ${result.error?.error_description}`,
                    undefined
                );
                console.log('OAuth2 Authorization Error:', result.error);
                try {
                    await oauth2Service.signOut(false);
                } catch (signOutError) {
                    console.log('Sign out error:', signOutError);
                }
                navigate('/');
            }
        };

        authorizeWithSession();
    }, [accounts, params.redirectUrl, params.state, params.clientId, navigate]);
};
